// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1a051e40","703":"a93198d8","787":"719d9526"}[chunkId] + ".chunk.js";
};